module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1507-94fe0212f4162f6238162952a4163e78.png";